import * as Departments from 'Modules/DepartmentModule';
import { Department } from '../EnumTypes/ActionEnumTypes';
import { toast } from 'react-toastify';
import { SVG } from 'Components';
import { SVG_TYPE } from 'Shared/enums';

const init = () => ({
  type: Department.ADD_DEPARTMENT_INIT,
});

export const success = (data) => ({
  type: Department.ADD_DEPARTMENT_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: Department.ADD_DEPARTMENT_FAILURE,
});

const addDepartment = (data) => async (dispatch) => {
  const id = toast.loading('Trwa dodawanie działu...');
  dispatch(init());
  try {
    const response = await Departments.Connector.addDepartment(data);
    dispatch(success(response.data));
    toast.update(id, {
      render: 'Pomyślnie dodano dział',
      type: toast.TYPE.SUCCESS,
      isLoading: false,
      closeButton: true,
      autoClose: 3000,
      icon: <SVG variant={SVG_TYPE.CIRCLE_GREEN} type={SVG_TYPE.CHECKED} />,
    });
    return response.data.department;
  } catch (err) {
    dispatch(failure());
    toast.update(id, {
      render: 'Nie udało się dodać działu',
      type: toast.TYPE.ERROR,
      isLoading: false,
      closeButton: true,
      autoClose: 3000,
      icon: <SVG variant={SVG_TYPE.CIRCLE_RED} type={SVG_TYPE.CHECKED} />,
    });
    return false;
  }
};

export default addDepartment;
